export const MAX_LEGAL_COMPANY_NAME_LENGTH = 100

export const MAX_COMPANY_IDENTIFICATION_NUMBER_LENGTH = 80
